import React, {useEffect, useState} from 'react';
import moment from 'jalali-moment';
import tools from '../../utils/tools';
import globalEnum from "../../enums/globalEnum";
import orderStatus = globalEnum.orderStatus;
import {setLoading} from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import {useDispatch} from "react-redux";
import {useParams} from "react-router-dom";
import endpoints from "../../config/endpoints";
const OrderInvoice = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [order, setOrder] = useState<any>({ orderProducts: [] , user: []});

  const handlePrint = () => {
    window.print();
  };

  const handleClose = () => {
    window.history.back();
  };

  const fetchData = async () => {
    dispatch(setLoading(true));
    const res = await restApi(endpoints.order.single + id, true).get();
    if (res.code == 200) {
      setOrder(res.data);
    }
    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const list = () => {
    if (!order.orderProducts || !Array.isArray(order.orderProducts)) {
      return (
        <tr>
          <td colSpan={8} className="invoice-no-data">هیچ محصولی یافت نشد</td>
        </tr>
      );
    }
    
    return order.orderProducts.map((orderProduct: any, index: number) => {
      // Real picked shelf(s) for this line — replaces the old free-text
      // product.warehouseLoc, which didn't reflect where this specific order
      // was actually picked from (and could be split across shelves).
      const pickedShelves = (order.orderShelfProducts || [])
        .filter((osp: any) => osp.productId === orderProduct.productId)
        .map((osp: any) => osp.shelf?.title)
        .filter(Boolean);
      const shelfDisplay = pickedShelves.length > 0 ? pickedShelves.join('، ') : '—';

      return (
      <tr key={index} className="invoice-data-row">
        <td className="invoice-index-cell">{index + 1}</td>
        <td className="invoice-sku-cell">{orderProduct.product.sku}</td>
        <td className="invoice-brand-cell">{orderProduct.product?.brand?.title?.replace("بلبرینگ - ", "").replace("کاسه نمد -","")}</td>
        <td className="invoice-items-cell">{orderProduct.itemsPerUnitType}</td>
        <td className="invoice-count-cell">{orderProduct.count}</td>
        <td className="invoice-total-cell">{orderProduct.count * orderProduct.itemsPerUnitType}</td>
        <td className="invoice-price-cell">{tools.formatPrice(orderProduct.singlePrice)}</td>
        <td className="invoice-location-cell">{shelfDisplay}</td>
      </tr>
    )});
  };

  const styles = `
    .custom-invoice-container {
      max-width: 800px;
      margin: 0 auto;
      padding: 20px;
      font-family: Arial, sans-serif;
      direction: rtl;
    }

    .custom-invoice-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      gap: 10px;
    }

    .custom-print-btn,
    .custom-close-btn {
      padding: 8px 16px;
      border: 1px solid #ccc;
      background: white;
      cursor: pointer;
      border-radius: 4px;
      font-size: 14px;
    }

    .custom-print-btn:hover,
    .custom-close-btn:hover {
      background: #f5f5f5;
    }

    .custom-print-icon,
    .custom-close-icon {
      margin-left: 5px;
    }

    .custom-invoice-header-content {
      text-align: center;
      margin-bottom: 30px;
    }

    .custom-invoice-header-content h1 {
      margin: 0 0 10px 0;
      font-size: 24px;
      font-weight: bold;
    }

    .custom-invoice-header-content h3 {
      margin: 0 0 20px 0;
      font-size: 18px;
      font-weight: normal;
    }

    .custom-invoice-header-content p {
      margin: 8px 0;
      font-size: 14px;
      text-align: right;
      line-height: 1.5;
    }

    .custom-invoice-table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 20px;
      table-layout: fixed;
    }

    .custom-invoice-table th,
    .custom-invoice-table td {
      border: 1px solid #000;
      padding: 8px 12px;
      text-align: center;
      font-size: 14px;
      vertical-align: middle;
    }

    .custom-invoice-table th {
      font-weight: bold;
      background: #f9f9f9;
    }

    .custom-invoice-table td {
      min-height: 30px;
    }

    /* Column width adjustments */
    .invoice-index-cell {
      width: 40px;
    }

    .invoice-sku-cell {
      width: 180px;
    }

    .invoice-brand-cell {
      width: 80px;
    }

    .invoice-items-cell {
      width: 90px;
    }

    .invoice-count-cell {
      width: 80px;
    }

    .invoice-total-cell {
      width: 70px;
    }

    .invoice-price-cell {
      width: 100px;
    }

    .invoice-location-cell {
      width: 80px;
    }

    .invoice-no-data {
      text-align: center;
      color: #666;
      font-style: italic;
    }

    .invoice-data-row:nth-child(even) {
      background-color: #f9f9f9;
    }

    .invoice-data-row:nth-child(odd) {
      background-color: white;
    }

    .custom-invoice-footer {
      margin-top: 30px;
      gap: 200px;
      padding-bottom: 30px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      border-top: 1px solid #ddd
    }

    .custom-invoice-footer p {
      margin: 0;
      font-size: 16px;
      font-weight: 500;
      line-height: 2;
      padding: 10px 20px;
      min-width: 150px;
      text-align: center;
    }

    .custom-invoice-footer p:first-child {
      margin-right: auto;
    }

    .custom-invoice-footer p:last-child {
      margin-left: auto;
    }
    @page {
  size: portrait;
  margin: 0.5cm;
}

    @media print {
  .no-print {
    display: none !important;
  }

  .custom-invoice-container {
    max-width: none;
    margin: 0;
    padding: 0;
    font-size: 12px;
  }

  .custom-invoice-table {
    width: 100% !important;
    font-size: 10px;
    border-collapse: collapse;
  }

  .custom-invoice-table th,
  .custom-invoice-table td {
    padding: 4px 6px;
    border: 1px solid #000 !important;
  }

  /* Make columns more flexible for printing */
  .invoice-index-cell {
    width: 40px !important;
  }

  .invoice-sku-cell {
    width: auto !important;
    min-width: 150px;
    max-width: 200px;
    word-wrap: break-word;
  }

  .invoice-brand-cell {
    width: auto !important;
    min-width: 120px;
  }

  .invoice-items-cell {
    width: 80px !important;
  }

  .invoice-count-cell {
    width: 70px !important;
  }

  .invoice-total-cell {
    width: 70px !important;
  }

  .invoice-price-cell {
    width: 90px !important;
  }

  .invoice-location-cell {
    width: 80px !important;
  }

  /* Ensure page breaks don't happen in bad places */
  .custom-invoice-table {
    page-break-inside: auto;
  }

  .custom-invoice-table tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }

  .custom-invoice-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    margin-top: 20px;
    page-break-inside: avoid;
  }

  /* Force black text for better printing */
  body {
    color: #000 !important;
    background: #fff !important;
  }
}
  `;

  return (
    <>
      <style>{styles}</style>
      <div className="custom-invoice-container">
        <div className="custom-invoice-header no-print">
          <button onClick={handlePrint} className="custom-print-btn">
            <i className="custom-print-icon">🖨️</i>
            چاپ فاکتور
          </button>
          <button onClick={handleClose} className="custom-close-btn">
            <i className="custom-close-icon">✕</i>
            بستن
          </button>
        </div>
        <div className="custom-invoice-header-content">
          <h1>حواله ارسال کالا از انبار</h1>
          <h3>شرکت پارس رول صنعت البرز</h3>
          <p>تاریخ: {moment(order.placedDate || order.createdAt).format('jYYYY/jMM/jDD')}</p>
          <p>نام و نام خانوادگی: {order.user.name}</p>
          <p>{order.user?.address?.text}</p>
          <p>آدرس: {order.user?.address?.postalCode}</p>
          <p>شماره فاکتور :{order?.code}</p>
        </div>
        <table className="custom-invoice-table">
          <thead>
          <tr>
            <th className="invoice-index-cell">ردیف</th>
            <th className="invoice-sku-cell">شماره فنی</th>
            <th className="invoice-brand-cell">برند</th>
            <th className="invoice-items-cell">تعداد در کارتن</th>
            <th className="invoice-count-cell">تعداد کارتن</th>
            <th className="invoice-total-cell">تعداد کل</th>
            <th className="invoice-price-cell">قیمت واحد</th>
            <th className="invoice-location-cell">شماره قفسه</th>
          </tr>
          </thead>
          <tbody>
          {list()}
          <tr>
            <td colSpan={4}>مجموع</td>
            <td>{order.orderProducts.reduce((acc, cur)=> acc + cur.count, 0)}</td>
            <td>{order.orderProducts.reduce((acc, cur)=> acc + (cur.count * (cur.itemsPerUnitType || 1)), 0)}</td>
            <td>{tools.formatPrice(order.orderProducts.reduce((acc, cur)=> acc + (cur.singlePrice * cur.count), 0))}</td>
            <td></td>
          </tr>
          </tbody>
        </table>
        <div className="custom-invoice-footer">
          {/*<p>درخواست کننده :</p>*/}
          {/*<p>تایید و امضا :</p>*/}
        </div>
      </div>
    </>
  );
};

export default OrderInvoice;